import { v4 as uuid } from 'uuid';

const resolveFileSrc = ({ fileName, bucket, folder }) => {
	const folderPath = (folder || []).join('/');
	const filename = fileName && fileName?.startsWith('/') ? fileName.slice(1) : fileName;
	const linksArr = [bucket, folderPath, filename].filter((v) => !!v);

	return [linksArr.join('/'), uuid()].join('?');
};

export { resolveFileSrc };
